import { render, staticRenderFns } from "./orderAddressEdit.vue?vue&type=template&id=78c77601&"
import script from "./orderAddressEdit.vue?vue&type=script&lang=js&"
export * from "./orderAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports